<template>
  <div class="flex flex-col gap-6">
    <WarningDisable permission="dump-credential" />
    <div class="grow">
      <div class="mb-2 flex items-baseline justify-between">
        <div class="text-base-content/80 mb-2 text-xl font-bold">
          Lịch sử Trích xuất mật khẩu
        </div>
        <button
          class="btn btn-primary"
          @click="startDumpCredential"
          :disabled="loading"
        >
          <span v-if="loading" class="loading loading-spinner"></span>
          <i v-else class="fa-solid fa-key mr-2"></i>
          Bắt đầu Trích xuất mật khẩu
        </button>
      </div>

      <Loading v-if="action_store.loading.get_action_history" />
      <template v-else-if="action_store.total_filter > 0">
        <div class="bg-base-100 mb-4 overflow-x-auto">
          <table class="table-pin-rows table-md table">
            <thead>
              <tr>
                <th></th>
                <th>Action ID</th>
                <th>Trạng thái</th>
                <th>Thời gian tạo</th>
              </tr>
            </thead>
            <tbody class="bg-base-200">
              <tr
                v-for="(action, idx) in action_store.actions"
                :key="action.id"
                class="hover:bg-base-300 cursor-pointer transition-colors"
              >
                <th>
                  {{
                    idx +
                    1 +
                    (number_from_query("page", 1) - 1) *
                      number_from_query("size", 24)
                  }}
                </th>
                <td>
                  <code class="badge badge-ghost badge-sm">{{
                    action.id || "N/A"
                  }}</code>
                </td>
                <td>
                  <ActionStatusBadge :status="action.status" />
                </td>
                <td class="whitespace-nowrap">
                  {{ dayjs(action.created).fromNow() }}
                </td>
                <td>
                  <a
                    v-show="isDownloadShown(action)"
                    type="button"
                    :href="`/api/v1/view/dump-credential/${client_id}/${action.id}`"
                    download
                    class="btn btn-ghost btn-sm"
                  >
                    Tải xuống
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Pagination :total_pages="action_store.total_pages" />
      </template>
      <NotFound v-else />
    </div>
  </div>
</template>

<script setup lang="ts">
import { number_from_query } from "@/api";
import ActionStatusBadge from "@/components/ActionStatusBadge.vue";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import Pagination from "@/components/PaginationTemplate.vue";
import dayjs from "dayjs";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { toast } from "vue3-toastify";
import { dumpCredential } from "@/api/action";
import WarningDisable from "../WarningDisable.vue";
import { use_action } from "../ExplorerV2/useAction";

const route = useRoute();
const client_id = computed(() => String(route.params.client_id));

const action_store = use_action();
const loading = ref(false);

const loadData = () => {
  action_store.get_action_history({
    type: "dump-credential",
  });
};
const startDumpCredential = async () => {
  try {
    loading.value = true;
    await dumpCredential(client_id.value);
    loadData();
  } catch (error: unknown) {
    if (error instanceof Error && error.message) {
      toast.error(error.message);
    }
  } finally {
    loading.value = false;
  }
};
const isDownloadShown = (action: { id?: string; status?: string }) => {
  return !!action.id && action.status === "complete";
};
onMounted(() => {
  loadData();
});
</script>
